// Resource names
export const RES = Object.freeze({
    USERS: 'users',
    MACHINES: 'machines',
    FIELD_GEOM: 'field_geo',
    FIELD_NOTES: 'field_notes',
    INTERNAL_NOTES: 'internal_notes',
    FIELD_PROPS: 'field_props',
    TRIMBLE: 'trimble',
})

// Action names
export const ACT = Object.freeze({ C: 'C', R: 'R', U: 'U', D: 'D' })

// This matrix defines the permissions for each role on each resource
export const ROLE_MATRIX = Object.freeze({
    nexat_admin: {
        [RES.USERS]: 'CRUD',
        [RES.MACHINES]: 'CRUD',
        [RES.FIELD_GEOM]: 'CRUD',
        [RES.FIELD_NOTES]: 'CRUD',
        [RES.INTERNAL_NOTES]: 'CRUD',
        [RES.FIELD_PROPS]: 'CRUD',
        [RES.TRIMBLE]: 'CRUD',
    },
    nexat_service: {
        [RES.USERS]: 'R',
        [RES.MACHINES]: 'RU',
        [RES.FIELD_GEOM]: 'CRU',
        [RES.FIELD_NOTES]: 'R',
        [RES.INTERNAL_NOTES]: 'CRUD',
        [RES.FIELD_PROPS]: 'CRU',
        [RES.TRIMBLE]: '',
    },
    nexat_view: {
        [RES.USERS]: '',
        [RES.MACHINES]: 'R',
        [RES.FIELD_GEOM]: 'R',
        [RES.FIELD_NOTES]: 'R',
        [RES.INTERNAL_NOTES]: 'R',
        [RES.FIELD_PROPS]: 'R',
        [RES.TRIMBLE]: '',
    },
    customer_admin: {
        [RES.USERS]: 'CRUD',
        [RES.MACHINES]: 'R',
        [RES.FIELD_GEOM]: 'CRUD',
        [RES.FIELD_NOTES]: 'CRUD',
        [RES.INTERNAL_NOTES]: '',
        [RES.FIELD_PROPS]: 'CRUD',
        [RES.TRIMBLE]: '',
    },
    customer_edit: {
        [RES.USERS]: 'R',
        [RES.MACHINES]: 'R',
        [RES.FIELD_GEOM]: 'CRUD',
        [RES.FIELD_NOTES]: 'CRUD',
        [RES.INTERNAL_NOTES]: '',
        [RES.FIELD_PROPS]: 'CRUD',
        [RES.TRIMBLE]: '',
    },
    customer_view: {
        [RES.USERS]: '',
        [RES.MACHINES]: 'R',
        [RES.FIELD_GEOM]: 'R',
        [RES.FIELD_NOTES]: 'R',
        [RES.INTERNAL_NOTES]: '',
        [RES.FIELD_PROPS]: 'R',
        [RES.TRIMBLE]: '',
    },
    sync: {
        [RES.USERS]: '',
        [RES.MACHINES]: 'R',
        [RES.FIELD_GEOM]: 'R',
        [RES.FIELD_NOTES]: '',
        [RES.INTERNAL_NOTES]: '',
        [RES.FIELD_PROPS]: 'R',
        [RES.TRIMBLE]: '',
    },
})
